import {
  START_EDITING_EVENT,
  CANCEL_EDITING_EVENT,
  UPDATE_EVENT
} from 'actions/Types';

export default (state = null, action) => {
  if (
    action.type === CANCEL_EDITING_EVENT ||
    action.type === `${UPDATE_EVENT}_SUCCESS`
  ) {
    return null;
  }

  if (action.type === START_EDITING_EVENT) {
    return action.payload;
  }

  return state;
};
